<template>
    <div class="buttons-cover">
        <div class="default-button selectedPlanButton">
            <template v-if="value === 'monthly'"> 1 AYLIK </template>
            <template v-if="value === 'monthly-3'"> 3 AYLIK <span class="free-months">(10% İndirim)</span> </template>
            <template v-if="value === 'monthly-6'"> 6 AYLIK <span class="free-months">(20% İndirim)</span> </template>
            <template v-if="value === 'annual'"> 1 Yıllık <span class="free-months">(30% İndirim)</span> </template>
            <template v-if="value === 'annual-2'"> 2 Yıllık <span class="free-months">(40% İndirim)</span> </template>
        </div>
        <div class="more_periodly">
            <div class="material-icons" @click="dropdown = !dropdown">change_circle</div>
            <div class="more_periodly-dropdown" v-if="dropdown" ref="dropdown">
                <div
                    @click="changeSelectedPlan('monthly')"
                    class="default-button"
                    :class="{ selectedPlanButton: value == 'monthly' }"
                >
                    AYLIK
                </div>
                <div
                    @click="changeSelectedPlan('monthly-3')"
                    class="default-button"
                    :class="{ selectedPlanButton: value == 'monthly-3' }"
                >
                    3 AYLIK <span class="free-months">(10% İndirim)</span>
                </div>
                <div
                    @click="changeSelectedPlan('monthly-6')"
                    class="default-button"
                    :class="{ selectedPlanButton: value == 'monthly-6' }"
                >
                    6 AYLIK <span class="free-months">(20% İndirim)</span>
                </div>
                <div
                    @click="changeSelectedPlan('annual')"
                    class="default-button"
                    :class="{ selectedPlanButton: value == 'annual' }"
                >
                    1 Yıllık <span class="free-months">(30% İndirim)</span>
                </div>
                <div
                    @click="changeSelectedPlan('annual-2')"
                    class="default-button"
                    :class="{ selectedPlanButton: value == 'annual-2' }"
                >
                    2 Yıllık <span class="free-months">(40% İndirim)</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChangePlan",
    props: {
        value: {
            type: String,
            default: "monthly",
        },
        minimize: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            dropdown: false,
            listener: null,
        };
    },
    methods: {
        changeSelectedPlan(planType) {
            this.$emit("input", planType);
            this.$emit("plan-changed", planType);
        },
    },
    watch: {
        dropdown(val) {
            if (this.dropdown) {
                this.listener = (e) => {
                    const dropdown = this.$refs.dropdown;
                    if (!dropdown?.contains(e.target)) this.dropdown = false;
                };
                setTimeout(() => {
                    document.addEventListener("click", this.listener);
                }, 1000);
            } else if (!this.dropdown) {
                document.removeEventListener("click", this.listener);
                this.listener = null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.buttons-cover {
    background: white;
    border-radius: 40px;
    display: flex;
    font-size: 14px;
    height: 40px;
    cursor: pointer;
    .more_periodly {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        position: relative;
        user-select: none;
        .material-icons {
            color: rgb(236 75 29);
        }
        &-dropdown {
            position: absolute;
            top: calc(100% + 10px);
            right: 0px;
            background-color: white;
            z-index: 9999;
            -webkit-box-shadow: 0px 0px 45px -5px rgba(0, 0, 0, 0.75);
            -moz-box-shadow: 0px 0px 45px -5px rgba(0, 0, 0, 0.75);
            box-shadow: 0px 0px 45px -15px rgba(0, 0, 0, 0.75);
            border-radius: 5px;
            animation-name: animationDropdown;
            animation-duration: 0.4s;
            overflow: hidden;
            border-radius: 20px;
            .default-button {
                height: 40px;
            }
        }
    }
}

@keyframes animationDropdown {
    0% {
        height: 0%;
    }
    100% {
        height: 200px;
    }
}
.selectedPlanButton {
    background-color: rgb(236 75 29) !important;
    color: white !important;
}

.default-button {
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-border-radius: 40px;
    -moz-border-radius: 40px;
    border-radius: 40px;
    transition: 0.2s all;
}

.free-months {
    font-size: 9px;
    margin-left: 3px;
}
</style>
